import { ComboboxItem, Group, Select } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export interface HierarchyDisciplineSelectProps {
  disciplineOptions: ComboboxItem[];
  disciplineValue: string | null;

  userOptions: ComboboxItem[];
  userValue: string | null;

  onDisciplineChange: (_value: string | null, option: ComboboxItem) => void;
  onUserChange: (_value: string | null, option: ComboboxItem) => void;

  isDisabled?: boolean;
  showUsers?: boolean;
}

const renderOptionLabel = (label: string) => {
  const parts = label.split(/(\([^)]*\))/g);

  return (
    <span>
      {parts.map(part => {
        if (part.startsWith('(') && part.endsWith(')')) {
          return (
            <span
              key={`parentheses-${part}`}
              style={{ fontSize: '0.85em', opacity: 0.8 }}
            >
              {part}
            </span>
          );
        }
        return <span key={`text-${part}`}>{part}</span>;
      })}
    </span>
  );
};

export function HierarchyDisciplineSelect(props: HierarchyDisciplineSelectProps) {
  const {
    disciplineOptions,
    disciplineValue,
    userOptions,
    userValue,
    onDisciplineChange,
    onUserChange,
    isDisabled,
    showUsers = true,
  } = props;
  const { t } = useTranslation();

  return (
    <Group flex={1}>
      <Select
        flex={1}
        label={t('hierarchy.discipline')}
        placeholder={t('hierarchy.discipline')}
        data={disciplineOptions}
        searchable
        disabled={isDisabled}
        value={disciplineValue}
        onChange={onDisciplineChange}
        renderOption={({ option }) => renderOptionLabel(option.label)}
      />
      {showUsers && (
        <Select
          flex={1}
          label={t('hierarchy.user')}
          placeholder={t('hierarchy.user')}
          searchable
          data={userOptions}
          disabled={disciplineValue == null || isDisabled}
          value={userValue}
          onChange={onUserChange}
          renderOption={({ option }) => renderOptionLabel(option.label)}
        />
      )}
    </Group>
  );
}
